module.exports = __webpack_public_path__ + "static/loxodon_selesnya-37fca7c135f9085b37a6e6b433a36a4d.webp";